import React from 'react'
import { Button, Label } from './styles'
import { IconComponent } from '~/assets/icons/component'

interface IExportButtonProps {
  disabled?: boolean
  onClick: React.MouseEventHandler
}

export const ExportButton = (props: IExportButtonProps): JSX.Element => {
  return (
    <Button {...props}>
      <span>
        <IconComponent name="fileExport" />
        <Label>Exportar</Label>
      </span>
    </Button>
  )
}
